// Weather alerts for this screen's city, proxied by our backend from the
// WeatherWalay triggered-notifications API. Authenticated with the same
// device key as overlay/weather polling.

import { API_BASE, SCREEN_ID, SCREEN_KEY } from '../../../config';

export async function fetchScreenAlerts() {
  const res = await fetch(`${API_BASE}/api/screens/${encodeURIComponent(SCREEN_ID)}/alerts`, {
    headers: { 'X-Screen-Key': SCREEN_KEY }
  });

  if (!res.ok) {
    throw new Error(`Alerts request failed (${res.status})`);
  }

  // { city, alerts: [{ id, title, text, severity, city, color, createdAt }], fetchedAt }
  return res.json();
}
